// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d388369a","174":"369abf7d","342":"de4230f0","501":"9261a2e4"}[chunkId] + ".chunk.js";
};